import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from '@heroui/react';

import AuthLayout, { AuthLink } from '../components/common/AuthLayout';
import Notice from '../components/common/Notice';
import { confirmEmailChange } from '../services/emailChange.service';
import { messageOf, EMAIL_CHANGE } from '../i18n/el';

// ΛΑ-02 / **D45**: το δεύτερο βήμα της αλλαγής διεύθυνσης, από τον σύνδεσμο του
// μηνύματος. Ίδια δομή με το `SetNewPasswordPage`: `AuthLayout`, `Notice`,
// επιστροφή στη σύνδεση.
//
// ⚠ **ΔΥΟ ΔΙΑΦΟΡΕΣ ΑΠΟ ΤΗΝ ΟΘΟΝΗ ΤΟΥ ΚΩΔΙΚΟΥ, ΚΑΙ ΟΙ ΔΥΟ ΣΚΟΠΙΜΕΣ.**
//
// **Πρώτη: καμία προεπαλήθευση του διακριτικού.** Η **D42** την απέρριψε ρητά —
// θα ήταν διαδρομή εκτός του πίνακα του §4.5.1, για ευκολία και όχι για
// λειτουργία, και θα επέστρεφε ταυτότητα λογαριασμού σε ανώνυμο αίτημα. Το
// τίμημα δηλώνεται και εδώ: ληγμένος σύνδεσμος δείχνει το κουμπί και αποτυγχάνει
// στην υποβολή, με το **ίδιο** μήνυμα με κάθε άλλη αποτυχία.
//
// **Δεύτερη: η επιβεβαίωση δεν γίνεται μόνη της στο άνοιγμα.** Οι υπηρεσίες
// ηλεκτρονικού ταχυδρομείου **προανοίγουν** συνδέσμους για έλεγχο ασφαλείας, και
// το διακριτικό είναι **μίας χρήσης**: με αυτόματη υποβολή θα το κατανάλωνε
// μηχανή πριν το δει άνθρωπος, και ο χρήστης θα έβλεπε «δεν ισχύει» σε σύνδεσμο
// που μόλις έφτασε. Η αποτυχία θα ήταν **αδιάγνωστη** — δεν υπάρχει τίποτα στην
// οθόνη που να τη διακρίνει από πραγματικά ληγμένο σύνδεσμο.

export default function ConfirmEmailPage() {
    const { token } = useParams();

    const [isPending, setIsPending] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    function handleConfirm() {
        setError('');
        setIsPending(true);

        confirmEmailChange(token).then(
            () => {
                setDone(true);
                setIsPending(false);
            },
            (apiError) => {
                setError(messageOf(apiError));
                setIsPending(false);
            }
        );
    }

    return (
        <AuthLayout
            title={EMAIL_CHANGE.confirmTitle}
            subtitle={done || error ? undefined : EMAIL_CHANGE.confirmSubtitle}
            footer={<AuthLink to="/login">{EMAIL_CHANGE.backToLogin}</AuthLink>}
        >
            {error && (
                <Notice status="danger" title={EMAIL_CHANGE.confirmFailedTitle}>{error}</Notice>
            )}

            {done && (
                <Notice status="success" title={EMAIL_CHANGE.confirmTitle}>
                    {EMAIL_CHANGE.confirmSuccess}
                </Notice>
            )}

            {/* Το κουμπί αποσύρεται μετά την επιτυχία: δεύτερο πάτημα στο ίδιο
                διακριτικό δίνει άρνηση, και θα διαβαζόταν ως αποτυχία κάτι που
                μόλις πέτυχε. Μετά από **σφάλμα** μένει, γιατί η αποτυχία μπορεί
                να ήταν προσωρινή — δίκτυο ή διαμόρφωση ταχυδρομείου. */}
            {!done && (
                <Button onPress={handleConfirm} isPending={isPending} className="mt-2">
                    {EMAIL_CHANGE.confirmAction}
                </Button>
            )}
        </AuthLayout>
    );
}
